// extracted by mini-css-extract-plugin
module.exports = {"display_background":"settings_display_background__3FBYb","toogle_container_margin":"settings_toogle_container_margin__1XceX","input_quota":"settings_input_quota__bjhSR"};